<template>
<ContentWrapper>
    <div class="content-heading">
      <div>{{`메시지 ${info.msgSeq == 0 ? '등록' : '수정'}`}}</div>
      <!-- Breadcrumb right aligned-->
      <ol class="breadcrumb ml-auto">
        <li class="breadcrumb-item">
          <a href="#">Home</a>
        </li>
        <li class="breadcrumb-item">
          마켓팅 관리
        </li>
        <li class="breadcrumb-item active">
          <a :href="page.prevUrl">{{page.prevTitle}}</a>
        </li>
      </ol>
    </div>

    <!-- 상세 -->
    <div class="card card-default book-list">
      <div class="card-body" style="background-color:#fff;">
        <form data-vv-scope="edit">
          <table class="table table-bordered table-hover" >
             <colgroup>
              <col width="12%"/>
              <col width="38%"/>
              <col width="12%"/>
              <col width="38%"/>
            </colgroup>
          <tbody>
            <tr>
              <td class="align-middle text-center">분류*</td>
              <td class="align-middle text-center">
                <b-form-select class="custom-select custom-select-sm mt-1" :options="page.categoryOption.noEmptyArray" v-model="info.msgCateCd"></b-form-select>
              </td>
              <td class="align-middle text-center">유형*</td>
              <td class="align-middle">
                <b-form-radio-group class="mt-2 mb-1"
                  v-model="info.sendTypeCd"
                  :disabled="page.msgSelectTypeCd!=''"
                  :options="data.sendTypeOption.noEmptyArray"
                  value-field="value"
                  text-field="text"
                  disabled-field="notEnabled"
                >
                </b-form-radio-group>
              </td>
            </tr>
            <tr>
              <td class="align-middle text-center">예약발송*</td>
              <td class="align-middle text-center">
                <div class="no-margin row">
                  <div class="col-auto">
                    <datepicker 
                      v-model="page.sendDate"
                      :disabled="info.sendNow=='Y'"
                      format="yyyy-MM-dd" 
                      :bootstrapStyling="true"
                      :monday-first="true"
                      :full-month-name="true"
                      placeholder="날짜 선택"
                      :calendar-button="true"
                      calendar-button-icon="far fa-calendar"
                      :clear-button="false"
                      :class="{'is-invalid':errors.has('edit.sendDate')}"
                      v-validate="'required'"
                      name="sendDate"
                      width="300px" >
                    </datepicker>
                  </div>
                  <div class="col-auto">
                    <b-form-timepicker 
                      v-model="page.sendTime"
                      :disabled="info.sendNow=='Y'"
                      placeholder="시간 선택"
                      :class="{'is-invalid':errors.has('edit.sendTime')}"
                      v-validate="'required'"
                      name="sendTime">
                    </b-form-timepicker>
                  </div>
                  <div class="col-auto">
                    <input type="checkbox" v-model="info.sendNow"
                      id="sendNow" true-value="Y" false-value="N">
                    <label class="font-weight-bold ml-1 mr-1" for="sendNow">즉시</label>
                  </div>
                </div>
              </td>
              <td class="align-middle text-center">대상선정 방식*</td>
              <td class="align-middle">
                <b-form-radio-group class="mt-2 mb-1"
                  v-model="info.msgSelectTypeCd"
                  :options="page.selectTypeOption.array"
                  value-field="value"
                  text-field="text"
                  disabled-field="notEnabled"
                >
                </b-form-radio-group>
              </td>
            </tr>
            <tr>
              <td class="align-middle text-center">제목*</td>
              <td class="align-middle text-center" colspan="3">
                <input type="text" v-model="info.title" :class="{'form-control':true, 'is-invalid': errors.has('edit.title')}"  v-validate="'required|min:2'"  name="title" style="width: 100%"  />
              </td>
            </tr>
            <tr>
              <td class="align-middle text-center">내용*</td>
              <td class="align-middle" colspan="3">
                <b-form-select 
                  v-if="info.sendTypeCd=='318001'"
                  class="custom-select custom-select-sm mt-1 mb-2" 
                  style="width:300px;"
                  :options="page.emailFormatOption"
                  @change="emailFormatChanged()"
                  v-model="page.emailFormat"></b-form-select>
                <jodit-editor
                  v-if="info.sendTypeCd=='318001'"
                  id="jodit_edit"
                  v-model="info.msg"
                  :config="jodit_config.config"
                  :buttons="jodit_config.buttons"
                  :plugins="jodit_config.plugins"
                  v-validate="'required|min:10'"
                  name="msgEmail"
                  :style="'min-height:300px;'"
                  :class="{'is-invalid':errors.has('edit.msgEmail')}"
                />
                <!-- <quill-editor
                  v-if="info.sendTypeCd=='318001'"
                  ref="myQuillEditor"
                  :options="{placeholder:'내용을 입력해주세요.'}"
                  v-model="info.msg"
                  v-validate="'required|min:10'"
                  name="msgEmail"
                  :style="'min-height:300px;'"
                  :class="{'is-invalid':errors.has('edit.msgEmail')}"
                /> -->
                <b-form-textarea
                  v-if="info.sendTypeCd=='318002' || info.sendTypeCd=='318004'"
                  id="textarea"
                  v-model="info.msg"
                  placeholder="내용을 입력해주세요."
                  :class="{'form-control':true, 'is-invalid': errors.has('edit.msgSms')}"
                  v-validate="'required|min:2'"
                  name="msgSms"
                  rows="5"
                  max-rows="10"
                ></b-form-textarea>
                <span v-if="info.sendTypeCd=='318002'">
                  {{page.msgByteCount}} byte(*80byte 초과 시, LMS/MMS로 발송됩니다.)
                </span>
              </td>
            </tr>
            <tr>
              <td class="align-middle text-center">등록자 ID</td>
              <td class="align-middle">
                {{info.regId}}
              </td>
              <td class="align-middle text-center">등록일시</td>
              <td class="align-middle ">
                {{info.regDt}}
              </td>
            </tr>
            <tr>
              <td class="align-middle text-center">수정자 ID</td>
              <td class="align-middle">
                {{info.updId}}
              </td>
              <td class="align-middle text-center">수정일시</td>
              <td class="align-middle ">
                {{info.updDt}}
              </td>
            </tr>
          </tbody>
          </table>
        </form>
        <div class="footer mt-3">
          <div class="float-right">
              <b-button @click="saveAndShowMessageTarget()" class="btn btn-b btn-info mr-2" variant="info mr-2">{{info.msgSeq == 0 ? '저장' : '수정'}}</b-button>
              <b-button v-show="info.msgSeq != 0" @click="remove()" class="btn btn-b btn-outline-danger mr-2" variant="outline-info mr-2">삭제</b-button>
              <b-button @click="list()" class="btn btn-b btn-outline-info mr-2" variant="outline-info mr-2">목록</b-button>
          </div>
        </div>
      </div>
    </div>

    <!-- 발송대상 검색 및 선택-->
    <div v-show="page.msgSelectTypeCd" class="card card-default book-list">
      <div class="card-header mt-2">
        <span class="text-bold h4">발송대상 검색</span>
        <div class="card-tool float-right">
          <b-btn v-if="page.msgSelectTypeCd=='108002'" class="btn btn-sm btn-outline-info mr-2" variant="outline-primary" 
            @click="downloadTemplate();">템플릿 다운로드</b-btn>
          <b-btn v-if="page.msgSelectTypeCd=='108002'" class="btn btn-sm btn-outline-info mr-2" variant="outline-primary"
            @click="addToTempMembersExcel();">파일 선택</b-btn>
            <input v-show="false" ref="fileInput" type="file" @change="readTempMembersExcel" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet">
          <b-btn class="btn btn-sm btn-outline-info mr-2" variant="outline-primary" 
            @click.prevent="openMemberSearchPopup();">회원 ID/이름 검색</b-btn>
          <b-btn class="btn btn-sm btn-outline-info mr-2" variant="outline-danger" 
            @click="saveWithSendMembers()">발송대상 등록</b-btn>
        </div>

        <!-- '조회' 발송대상 선택 -->
        <div v-if="page.msgSelectTypeCd=='108001' || (page.msgSelectTypeCd=='108002' && (info.sendTypeCd!='318002' && info.sendTypeCd!='318001'))" class="form-group mt-3 pl-2" style="border:1px solid #23b7e5">
          <div class="form-group row mt-3" style="width:100%">
            <div class="col-auto">
              <label class="col-form-label">회원 유형</label>
            </div>
            <div class="col-auto">
              <b-input-group class="mt-2 mb-1">
                <div class="form-check mb-2">
                  <input class="form-check-input" :id="`user-type-all`" v-model="data.selectAllUserType"
                    value="" type="checkbox"/>
                  <label class="form-check-label" :for="`user-type-all`">전체</label>
                </div>
                <div v-for="(item, index) in page.userTypeOption.noEmptyArray" :key="index" class="form-check mb-2 ml-3">
                  <input class="form-check-input" :id="`user-type-${index}`" v-model="data.selectedUserTypes" 
                    :value="item.value" type="checkbox"/>
                  <label class="form-check-label" :for="`user-type-${index}`">{{item.text}}</label>
                </div>
              </b-input-group>
            </div>

            <div class="col-auto">
              <label class="col-form-label">문자수신 동의</label>
            </div>
            <div class="col-auto">
                <b-form-select :options="page.useYnOption" v-model="data.params.smsYn" class="custom-select custom-select-sm"></b-form-select>
            </div>

            <div class="col-auto">
              <label class="col-form-label">메일수신 동의</label>
            </div>
            <div class="col-auto">
                <b-form-select :options="page.useYnOption" v-model="data.params.emailYn" class="custom-select custom-select-sm"></b-form-select>
            </div>

            <div class="col-auto">
              <label class="col-form-label">조건문 추가</label>
            </div>
            <div class="col-auto">
                <b-form-input type="text" v-model="data.params.additionalWhere" />
            </div>
          </div>

          <div class="form-group no-margin row">
            <div class="col-auto">
              <label class="col-form-label">학교급</label>
            </div>
            <div class="col-auto">
                <b-form-select :options="page.schoolGrdCdOption.array" 
                  :disabled="data.studentOrParentSelected"
                  v-model="data.params.schlGrdCd" 
                  @change="schoolGradeChanged();" 
                  class="custom-select custom-select-sm"></b-form-select>
            </div>

            <div class="col-auto">
              <label class="col-form-label">과목</label>
            </div>
            <div class="col-auto">
                <b-form-select :options="page.subjectCdOption"
                  :disabled="data.studentOrParentSelected"
                  v-model="data.params.subjectCd" 
                  class="custom-select custom-select-sm"></b-form-select>
            </div>

            <div class="col-auto ml-5">
              <b-btn class="btn btn-sm btn-outline-info" variant="outline-primary" @click="searchUser()">검색</b-btn>
            </div>
          </div>
        </div>

        <!-- '파일' 발송대상 선택 -->
        <div v-if="page.msgSelectTypeCd=='108002' && (info.sendTypeCd=='318002' || info.sendTypeCd=='318001')" class="form-group mt-3 pl-2" style="border:1px solid #23b7e5">
          <div class="form-group row mt-2">
            <div class="col-auto">
              <span class="text-bold h4">비회원 개별 등록</span>
            </div>
          </div>
          <!-- 비회원 전화번호 -->
          <div v-show="info.sendTypeCd=='318002'" class="form-group no-margin row">
            <div class="col-auto">
              <label class="col-form-label">이름</label>
            </div>
            <div class="col-auto">
              <input type="text" v-model="data.noMember.name" class="form-control" style="width:200px"
                :class="{'is-invalid':errors.has('sms.name')}"
                data-vv-scope="sms"
                v-validate="'required|min:2'" name="name">
            </div>

            <div class="col-auto">
              <label class="col-form-label">휴대폰</label>
            </div>
            <div class="col-auto">
              <input type="text" v-model="data.noMember.phone" class="form-control" style="width:200px"
                :class="{'is-invalid':errors.has('sms.phone')}"
                data-vv-scope="sms"
                v-validate="{required:true, regex:/^(^02.{0}|^01.{1}|[0-9]{3})([0-9]{3,4})([0-9]{4})$/}" name="phone">
            </div>
            <div class="col-auto ml-5">
              <b-btn class="btn btn-sm btn-outline-info" variant="outline-primary" @click.prevent="addNoMember('sms')">추가</b-btn>
            </div>
          </div>
          <!-- 비회원 이메일 -->
          <div v-show="info.sendTypeCd=='318001'" class="form-group no-margin row">
            <div class="col-auto">
              <label class="col-form-label">이름</label>
            </div>
            <div class="col-auto">
              <input type="text" v-model="data.noMember.name" class="form-control" style="width:200px"
                :class="{'is-invalid':errors.has('email.name')}"
                data-vv-scope="email"
                v-validate="'required|min:2'" name="name">
            </div>

            <div class="col-auto">
              <label class="col-form-label">이메일</label>
            </div>
            <div class="col-auto">
              <input type="text" v-model="data.noMember.email" class="form-control" style="width:200px"
                :class="{'is-invalid':errors.has('email.email')}"
                data-vv-scope="email"
                v-validate="'required|email'" name="email">
            </div>
            <div class="col-auto ml-5">
              <b-btn class="btn btn-sm btn-outline-info" variant="outline-primary" @click.prevent="addNoMember('email')">추가</b-btn>
            </div>
          </div>
        </div>

        <!-- 1. 임시 대상 -->
        <span class="text-bold h5">조회 결과 총 {{data.count}}명</span>
        <ShowCounter label="Show" class="ml-1" :data="data" @search="searchTemp" />
        <table class="table table-striped table-bordered table-hover">
          <thead>
            <tr>
              <td width="4%" style="text-align:center">No</td>
              <td width="10%" style="text-align:center" >이름</td>
              <td width="10%" style="text-align:center" >회원ID</td>
              <td width="10%" style="text-align:center" >회원유형</td>
              <td width="10%" style="text-align:center" >휴대폰</td>
              <td width="10%" style="text-align:center" >문자수신 동의</td>
              <td width="10%" style="text-align:center" >이메일</td>
              <td width="10%" style="text-align:center" >메일수신 동의</td>
              <td width="10%" style="text-align:center" >삭제</td>
            </tr>
          </thead>
          <tbody>
            <tr v-show="data.count==0" class="text-center"><td colspan="9">No matching records</td> </tr>
            <template v-for="(item, index) in data.list">
              <tr :key="index">
                <td class="align-middle text-center">{{data.params.limit*(data.params.page-1) + index+1}}</td>
                <td class="align-middle text-center">{{item.name}}</td>
                <td class="align-middle text-center">{{item.maskedLoginId}}</td>
                <td class="align-middle text-center">{{page.userTypeOption.getUserTypeText(item.typeCd)}}</td>
                <td class="align-middle text-center">{{item.phone}}</td>
                <td class="align-middle text-center">{{item.smsYn}}</td>
                <td class="align-middle text-center">{{item.email}}</td>
                <td class="align-middle text-center">{{item.emailYn}}</td>
                <td class="align-middle text-center">
                  <button @click="removeFromTempMembers(item.loginId, item.noMemberId)" class="btn btn-danger">삭제</button>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
        <div class="form-group no-margin row mt-2" style="width:100%">
          <div class="col-auto">
            <b-input-group class="mt-2">
              <div class="form-check">
                <input class="form-check-input" id="sendForce" v-model="page.forceSendYn" 
                  true-value="Y" false-value="N" type="checkbox"/>
                <label class="form-check-label" for="sendForce">강제발송 (마켓팅 수신동의 관계없이 발송)</label>
              </div>
            </b-input-group>
          </div>
        </div>  
        <div class="d-flex">
          <!--paging component-->
          <Pagenation :data="data" @next="dataAction.next(searchTemp)" @prev="dataAction.prev(searchTemp)" @first="dataAction.first(searchTemp)" @last="dataAction.last(searchTemp)" :key="data.params.page"/>
        </div>

      </div>
    </div>

    <!-- 2. 발송 대상 -->
    <div v-show="page.msgSelectTypeCd" class="card card-default book-list">
      <div class="card-body">
        <span class="text-bold h4">발송대상</span>
        <ShowCounter label="Show" class="ml-1 mt-1" :data="sendData" @search="searchSend" />

        <table class="table table-striped table-bordered table-hover">
          <thead>
            <tr>
              <td width="4%" style="text-align:center">No</td>
              <td width="10%" style="text-align:center" >이름</td>
              <td width="10%" style="text-align:center" >회원ID</td>
              <td width="10%" style="text-align:center" >회원유형</td>
              <td width="10%" style="text-align:center" >휴대폰</td>
              <td width="10%" style="text-align:center" >문자수신 동의</td>
              <td width="10%" style="text-align:center" >이메일</td>
              <td width="10%" style="text-align:center" >메일수신 동의</td>
              <td width="10%" style="text-align:center" >강제 발송</td>
              <td width="10%" style="text-align:center" >등록 일시</td>
            </tr>
          </thead>
          <tbody>
            <tr v-show="sendData.count==0" class="text-center"><td colspan="10">발송대상 회원이 없습니다.</td> </tr>
            <template v-for="(item, index) in sendData.list">
              <tr :key="index">
                <td class="align-middle text-center">{{sendData.params.limit*(sendData.params.page-1) + index+1}}</td>
                <td class="align-middle text-center">{{item.name}}</td>
                <td class="align-middle text-center">{{item.maskedLoginId}}</td>
                <td class="align-middle text-center">{{page.userTypeOption.getUserTypeText(item.typeCd)}}</td>
                <td class="align-middle text-center">{{item.phone}}</td>
                <td class="align-middle text-center">{{item.smsYn}}</td>
                <td class="align-middle text-center">{{item.email}}</td>
                <td class="align-middle text-center">{{item.emailYn}}</td>
                <td class="align-middle text-center">{{item.forceSendYn}}</td>
                <td class="align-middle text-center">{{item.regDt}}</td>
              </tr>
            </template>
          </tbody>
        </table>
        <div class="d-flex mt-2">
          <!--paging component-->
          <Pagenation :data="sendData" @next="sendDataAction.next(searchSend)" @prev="sendDataAction.prev(searchSend)" @first="sendDataAction.first(searchSend)" @last="sendDataAction.last(searchSend)"/>
        </div>
      </div>
    </div>
    
    <b-modal size="lg" v-model="page.showMemberSearchPopup" hide-footer>
      <template #modal-title>
        <span class="text-bold h4">회원 조회</span>
      </template>
      <MemberSearchPopup @save="addToTempMembers" @close="closeMemberSearchPopup"/>
    </b-modal>

    <loading :active="modalLoading" :is-full-page="true"/>
  </ContentWrapper>    
</template>

<style scoped>
  .is-invalid {
    border: 1px solid red;
  }
</style>
<script>
import store from "@/store/index";
import { reactive, ref, watch, computed, onMounted } from '@vue/composition-api'
import {dataObject, ValueTexts, messageSendTypes, userTypeCd, YnOption, schoolGrdCdOption, subjectCd1, subjectCd2, subjectCd3} from "@/utils/Constants";
import * as messageApi from "@/api/marketing/MessageApi";
import * as memberApi from "@/api/mem/MemberAPI";
import MemberSearchPopup from "./memberSearchPopup";
import Pagenation from "@/components/Common/Pagenation";
import {TableActionClass} from "@/utils/TableActionClass";
import Datepicker from 'vuejs-datepicker';
import ShowCounter from "../../components/Common/ShowCounter";
import {downloadUrl} from "@/utils/common-util";
import Xlsx from 'xlsx';
import moment from 'moment';

// 로딩처리
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

/*
// quill Editor
import { quillEditor } from "vue-quill-editor";   
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
*/

// jodit Editor
import 'jodit/build/jodit.min.css'
import { JoditEditor } from 'jodit-vue'
import { jodit_config } from '@/components/Common/jodit_config'


export default {
    components: {MemberSearchPopup, Datepicker, ShowCounter, Pagenation, Loading, JoditEditor},
    props: {
      seq:{
        type:Number|String,
        default:0, // 0: 등록, 그외: 수정
      },
    },
    setup(props, {root}) {
      const isTest = true;
      const modalLoading = ref(false);

      const userTypeOption = new ValueTexts(userTypeCd);

      // 임시회원 목록을 위한 데이터
      const _dataObject = _.cloneDeep(dataObject);
      _dataObject.totalMembers = [];
      _dataObject.selectedUserTypes = userTypeOption.noEmptyArray.map((item) => item.value);
      _dataObject.studentOrParentSelected = true;
      _dataObject.selectAllUserType = computed({
        get() {
          return data.selectedUserTypes.length == userTypeOption.noEmptyArray.length;
        },
        set(newValue) {
          if (newValue) {
            data.selectedUserTypes = userTypeOption.noEmptyArray.map((item) => item.value);
          } else {
            data.selectedUserTypes = [];
          }
        }
      });
      _dataObject.noMember = {
        name: '',
        phone: '',
        email: ''
      };
      const data = reactive(_dataObject);
      data.sendTypeOption = messageSendTypes;
      data.params.smsYn = '';
      data.params.emailYn = '';
      data.params.schlGrdCd = '';
      data.params.subjectCd = '';

      // 발송회원 목록을 위한 데이터
      const _sendDataObject = _.cloneDeep(dataObject);
      _sendDataObject.totalMembers = [];
      const sendData = reactive(_sendDataObject);

      const emailFormatOption = [
        {value:'', text:'선택'},
        // {value:'email_common', text:'공통답변'},
        {value:'email_basic', text:'기본 템플릿'},
        {value:'email_dormancy', text:'휴면계정전환예정안내'},
        {value:'email_ad', text:'광고성정보수신여부안내'},
        // {value:'email_ad_all', text:'광고성정보수신여부안내_전체'},
        {value:'email_privacy', text:'개인정보이용내역안내'},
      ];

      const page = reactive({
        title:'',
        prevUrl:'',
        prevTitle:'',
        sendDate:null,
        sendTime:'',
        forceSendYn: 'Y',
        showMemberSearchPopup:false,
        msgSelectTypeCd:'',  // '저장'이 될때 또는 상세일때 설정된다., '신규' 최초에 보여줄때는 빈문자열이다.
        categoryOption : new ValueTexts([
          {value:'390001', text:'이벤트안내'},
          {value:'390002', text:'공지'},
          {value:'390003', text:'안내'},
        ]),
        selectTypeOption : new ValueTexts([
          {value:'108001', text:'조회'},
          {value:'108002', text:'파일'},
        ]),
        userTypeOption : userTypeOption,
        useYnOption : [
          {value:'', text:'전체'},
          {value:'Y', text:'Y'},
          {value:'N', text:'N'}
        ],
        emailFormatOption: emailFormatOption,
        emailFormat:'',
        schoolGrdCdOption : new ValueTexts(schoolGrdCdOption),
        subjectCdOption : [
          {value:'', text:'학교급을 선택해주세요'}
        ],
        msgByteCount : computed(() => {
          let byteCount = 0;
          for (let i=0; i<info.msg.length; ++i) {
            // 기본 한글 2바이트 처리
            (info.msg.charCodeAt(i) > 127) ? byteCount += 2 : byteCount++ ;
          }
          return byteCount;
        }),
      });
      const info = reactive({
        msgSeq:props.seq,
        msgCateCd: page.categoryOption.array[0].value,
        sendTypeCd: data.sendTypeOption.noEmptyArray[0].value,
        msgSelectTypeCd : page.selectTypeOption.array[0].value,
        title: '',
        msg: '',
        schDt: '',
        sendNow:'N',
        systemYn : 'N', // 항상 관리자 발송이다.
        regId : '',
        regDt : '',
        updId : '',
        updDt : '',
      });
      
      page.prevUrl = '/marketing/messageList';
      page.prevTitle = '메시지 관리';

      const retVals = {
        isTest,
        modalLoading,
        data,
        sendData,
        page,
        info,
        jodit_config,
        ...methods(props, data, sendData, page, info),
        dataAction: new TableActionClass(data),
        sendDataAction: new TableActionClass(sendData),
      }

      onMounted(async () => {
        await retVals.detail();
      });
      watch(() => info.sendTypeCd, (newValue, oldValue) => {
        // todo: sendType을 바꿨을때, jodit_edit의 textarea가 남는 현상 해결을 위해 임시로 처리.
        //       setTimeout이 없으면 작동이 안된다. 지금은 화면에 보이고 사라지는 현상 남음. 추후 해결.
        //       nextTick은 작동 안됨.
        if (newValue !='318001') {
          setTimeout(function() {
            console.log('textarea[name="msgEmail"] count: ', $('textarea[name="msgEmail"]').length);
            $('textarea[name="msgEmail"]').remove();
          }, 1);
        }
      });
      watch(() => info.sendNow, (newValue, oldValue) => {
        console.log('info.sendNow: ', {newValue, oldValue})

        if (newValue == 'Y') {
          const now = new Date();
          page.sendDate = now;
          page.sendTime = moment(now).format('HH:mm');
        } else {
          page.sendDate = null;
          page.sendTime = '';
        }
      });
      watch(() => data.selectedUserTypes, async (userTypes, oldUserTypes) => {
        if (userTypes.includes('105005') || userTypes.includes('105006')) {
          data.studentOrParentSelected = true;
          data.params.schlGrdCd = '';
          retVals.schoolGradeChanged();
        } else {
          data.studentOrParentSelected = false;
        }
      });

      return retVals;
    }
}

function methods(props, data, sendData, page, info) {

  function unshiftPop(list, sum) {
    // list.unshift(...sum); // 갯수가 많을 때 call stack exceed 발생. 
    while (sum.length > 0) {
      list.unshift(sum.pop());
    }
  }
  
  // 상세
  async function detail() {
    if (info.msgSeq != 0) {
      const params = {msgSeq:info.msgSeq};
      const result = await messageApi.getMessageDetail(params);
      
      if (result && result.data) {
        for (const property in result.data) {
          if (property == 'schDt') {
            const schDt = result.data[property];
            const dateTimes = schDt.split(' ');
            if (dateTimes.length == 2) {
              page.sendDate = moment(dateTimes[0]).toDate();
              const times = dateTimes[1].split('.');
              page.sendTime = times[0];
            }
          } else if (info.hasOwnProperty(property)) {
            if (property == 'msgSelectTypeCd') {
              // 사용자 목록을 보여주기 위해
              page[property] = result.data[property];
              // 사용자 목록
              sendData.totalMembers.splice(0, sendData.totalMembers.length);
              const userList = result.data.userList;
              // sendData.totalMembers.unshift(...userList);
              // unshiftPop(sendData.totalMembers, userList);
              sendData.totalMembers = userList.concat(sendData.totalMembers);
              this.searchSend(1);
            } 
            info[property] = result.data[property];
          }
        }
      }
    }
  }

  async function remove() {
    if (!confirm('정말 삭제하시겠습니까?')) {
      return;
    }
    const params = {msgSeq : info.msgSeq};
    const result = await messageApi.deleteMessage(params);
    alert('삭제했습니다.');
    this.$router.go(-1);
  }

  function list() {
    this.$router.go(-1);
  }

  function setSubjectOption() {
    const allValue = {value:'', text:'전체'};

    switch(data.params.schlGrdCd){
      case '301002' : 
        page.subjectCdOption = [allValue, ...subjectCd1];
        break;
      case '301003' : 
        page.subjectCdOption = [allValue, ...subjectCd2];
        break;
      case '301004' : 
        page.subjectCdOption = [allValue, ...subjectCd3];
        break;
      case '':
        page.subjectCdOption =[{value:'',text:'학교급을 선택해주세요.'}];
        break;
    }
  }

  async function schoolGradeChanged() {
    this.setSubjectOption();
    data.params.subjectCd = '';
  }

  function emailFormatChanged() {
    console.log('emailFormatChanged, ', page.emailFormat);
    if (page.emailFormat == 'email_common') {
      info.msg = `<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8">
</head>
<body>
	<div style="border:1px solid #d6d6d6; min-width:700px">
		<div style="display: table; width: 100%; height: 80px;background:#f6f6f6">
			<div style="display: table-cell; vertical-align: middle; width: 164px;padding:15px">
				<img src="https://www.ybmbooksam.com/img/common/booksam_ci.png" style="width: 164px; height: 35px;"/>
			</div>
			<div style="display: table-cell; vertical-align: middle; padding-left: 30px;">
				<h2 style="font-size:22px; line-height:28px">#{title}</h2>
			</div>
			<div style="display: table-cell; vertical-align: middle; text-align:right; padding-right:15px">
				<a href="https://www.ybmbooksam.com/html/board/notice_list" style="display:inline-block; background:#ccc; color:#fff; text-decoration:none; height:40px; line-height:40px; padding:0 15px;">고객센터</a>
			</div>
		</div>
		<div style="padding:30px">
			#{contents}
		</div>

		<div style="background:#f6f6f6; border-top:1px solid #ededed; padding:15px">
			<ul style="margin:0; padding:0">
				<li style="list-style:none; font-size:13px; line-height:16px; color:#666">본 메일은 정보통신망이용촉진 및 정보보호 등에 관한 법률 및 시행규칙을 준수한 발신전용 메일입니다.</li>
				<li style="list-style:none; font-size:13px; line-height:16px; color:#666">메일 수신을 원하지 않거나 메일주소 변경을 원하시면 <a href="https://www.ybmbooksam.com/html/mypage/myinfo_checkpw" target="_blank">[회원정보수정]</a> 을 클릭하여 주시기 바랍니다.</li>
				<li style="list-style:none; font-size:13px; line-height:16px; color:#666">궁금하신 점은 이용 중이신 YBM북샘 홈페이지 고객센터 또는 대표번호 02-2000-0500로 문의해 주시기 바랍니다.</li>
			</ul>
			
		</div>
	</div>
</body>
</html>`;
    } else if (page.emailFormat == 'email_basic') {
      info.msg = `
<!DOCTYPE html>
<html lang="ko">
<head>
<meta charset="utf-8">
<title>스마트스쿨</title>
</head>
<body>
    <table border="0" cellpadding="0" cellspacing="0" style="width:1000px;background-color:#fff;"> 
        <tbody>
            <tr>
                <td style="border-top:15px solid #EA7D3C"></td>
            </tr>
            <tr>
                <td style="height:30px;"></td>
            </tr>
            <tr>
                <td style="padding:0 40px;font-family:'Noto Sans KR','나눔고딕',NanumGothic,'맑은 고딕', SDNeoGothic, SDGothicNeo, '돋움', 'dotum', sans-serif;""> 
                    <table border="0" cellpadding="0" cellspacing="0" style="width:100%"> 
                        <tbody>
                            <tr>                                            
                                <!--<td style="width:40px"></td>-->
                                <td>
                                    <table border="0" cellpadding="0" cellspacing="0" style="width:100%"> 
                                        <tbody>
                                            <tr>
                                                <td>
                                                    <table border="0" cellpadding="0" cellspacing="0" style="width:100%"> 
                                                        <tbody>
                                                            <tr>

                                                                <td align="left" style="height:16px;margin:0;padding:0;vertical-align:top;font-size:0;line-height:0"> 
                                                                    <img src="https://www.ybmsmartschool.com/membership/img/mail_logo2.png" style="width:143px;height:48px;vertical-align:top;border:0;" loading="lazy">
                                                                </td>  
                                                    
                                                                <td align="right">
                                                                    <table border="0" cellpadding="0" cellspacing="0" style="width:125px"> 
                                                                        <tbody>
                                                                            <tr>
                                                                                <td>
                                                                                    <a href="https://www.ybmsmartschool.com/"  target="_blank" rel="noreferrer noopener" ><img border="0" src="https://www.ybmsmartschool.com/membership/img/mail_home2.png" alt="홈" loading="lazy"></a>
                                                                                    
                                                                                </td>
                                                                                <td  width="30"></td>
                                                                                <td style="height:48px;">
                                                                                    <a href="https://www.ybmsmartschool.com/notice/list"  target="_blank" rel="noreferrer noopener" ><img border="0" src="https://www.ybmsmartschool.com/membership/img/mail_custom2.png" alt="고객센터" loading="lazy"></a>
                                                                                </td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </table>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>                                                                
                                                </td>
                                            </tr>
                                            <tr><td style="height:56px"></td></tr>
                                            <tr>
                                                <td><span style="color:#000000;font-size: 24px;font-weight: 400;line-height: 35px;letter-spacing: -0.05em;text-align: left;"">YBM스마트스쿨</span><br>
                                                    <span style="color:#000000;font-size: 40px;font-weight: 700;line-height: 58px;letter-spacing: -0.05em;text-align: left;">제목</span>
                                                </td>
                                            </tr>
                                            <tr><td style="height:43px"></td></tr>
                                            <tr>
                                                <td style="color:#000000;font-size: 18px;font-weight: 400;line-height: 26px;">
                                                    내용입니다.<br>
                                                    내용입니다.<br>
                                                    내용입니다.<br>
                                                    내용입니다.<br>
                                                    내용입니다.<br>
                                                </td>
                                            </tr>                                            
                                            <tr><td style="height:60px"></td></tr>
                                            <tr>
                                                <td>
                                                    <ul style="font-size: 16px;font-weight: 400;line-height: 23px;color: #707070;margin:0;">
                                                        <li>본 메일은 정보통신망 이용촉진 및 정보보호 등에 관한 법률 및 시행규칙을 준수한 발신전용 메일입니다.</li>
                                                        <li>메일 수신을 원하지 않거나 메일 주소 변경을 원하시면 <a href="https://www.ybmsmartschool.com/myInfo/confirm_passwd?originalUrl=/myInfo/modify_user_info" target="_blank">[회원정보수정]</a> 을 클릭하여 주시기 바랍니다.</li>
                                                        <li>궁금하신 점은 이용 중이신 YBM스마트스쿨 홈페이지 고객센터 또는 대표번호 02-2000-0599로 문의해 주시기 바랍니다.</li>

                                                    </ul>
                                                </td>
                                            </tr>
                                            <tr><td style="height:30px"></td></tr>
                                        </tbody>
                                    </table>
                                </td>
                                <!--<td style="width:40px"></td>-->
                            </tr>
                            
                        </tbody> 
                    </table> 
                </td>
            </tr>
        </tbody>
    </table>
    
    <table border="0" cellpadding="0" cellspacing="0" style="width:1000px;background-color: #F1F1F1; "> 
        <tr>
            <td style="padding:40px 40px 35px 40px;font-family:'Noto Sans KR','나눔고딕',NanumGothic,'맑은 고딕', SDNeoGothic, SDGothicNeo, '돋움', 'dotum', sans-serif;""> 
                <p style="color: #707070;font-size: 16px;font-weight: 500;line-height: 23px;margin:0;">㈜와이비엠 서울시 종로구 종로 104 대표이사 허문호, 정용환 사업자등록번호 101-81-14655</p>
                <p style="color: #707070;font-size: 16px;font-weight: 400;line-height: 23px;margin:0;margin-top:10px;">
                고객센터 : 02-2000-0599 FAX : 02-2000-0426 E-mail : smartschool@ybm.co.kr<br>
                Copyright ⓒ (주)와이비엠. All rights reserved.</p>
            </td>
        </tr>
    </table>
        
</body>
</html>
    `;
    } else if (page.emailFormat == 'email_dormancy') {
      info.msg = `
      <!DOCTYPE html>
<html lang="ko">
<head>
<meta charset="utf-8">
<title>스마트스쿨</title>
</head>
<body>
    <table border="0" cellpadding="0" cellspacing="0" style="width:1000px;background-color:#fff;"> 
        <tbody>
            <tr>
                <td style="border-top:15px solid #EA7D3C"></td>
            </tr>
            <tr>
                <td style="height:30px;"></td>
            </tr>
            <tr>
                <td style="padding:0 40px;font-family:'Noto Sans KR','나눔고딕',NanumGothic,'맑은 고딕', SDNeoGothic, SDGothicNeo, '돋움', 'dotum', sans-serif;""> 
                    <table border="0" cellpadding="0" cellspacing="0" style="width:100%"> 
                        <tbody>
                            <tr>                                            
                                <!--<td style="width:40px"></td>-->
                                <td>
                                    <table border="0" cellpadding="0" cellspacing="0" style="width:100%"> 
                                        <tbody>
                                            <tr>
                                                <td>
                                                    <table border="0" cellpadding="0" cellspacing="0" style="width:100%"> 
                                                        <tbody>
                                                            <tr>

                                                                <td align="left" style="height:16px;margin:0;padding:0;vertical-align:top;font-size:0;line-height:0"> 
                                                                    <img src="https://www.ybmsmartschool.com/membership/img/mail_logo2.png" style="width:143px;height:48px;vertical-align:top;border:0;" loading="lazy">
                                                                </td>  
                                                    
                                                                <td align="right">
                                                                    <table border="0" cellpadding="0" cellspacing="0" style="width:125px"> 
                                                                        <tbody>
                                                                            <tr>
                                                                                <td>
                                                                                    <a href="https://www.ybmsmartschool.com/"  target="_blank" rel="noreferrer noopener" ><img border="0" src="https://www.ybmsmartschool.com/membership/img/mail_home2.png" alt="홈" loading="lazy"></a>
                                                                                    
                                                                                </td>
                                                                                <td  width="30"></td>
                                                                                <td style="height:48px;">
                                                                                    <a href="https://www.ybmsmartschool.com/notice/list"  target="_blank" rel="noreferrer noopener" ><img border="0" src="https://www.ybmsmartschool.com/membership/img/mail_custom2.png" alt="고객센터" loading="lazy"></a>
                                                                                </td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </table>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>                                                                
                                                </td>
                                            </tr>
                                            <tr><td style="height:56px"></td></tr>
                                            <tr>
                                                <td><span style="color:#000000;font-size: 24px;font-weight: 400;line-height: 35px;letter-spacing: -0.05em;text-align: left;"">YBM스마트스쿨</span><br>
                                                    <span style="color:#000000;font-size: 40px;font-weight: 700;line-height: 58px;letter-spacing: -0.05em;text-align: left;">휴면계정 전환 예정 안내</span> 
                                                </td>
                                            </tr>
                                            <tr><td style="height:43px"></td></tr>
                                            <tr>
                                                <td style="color:#000000;font-size: 18px;font-weight: 400;line-height: 26px;">
                                                    안녕하세요.<br>
                                                    YBM스마트스쿨 회원님께 휴면계정 전환에 대해 다음과 같이 안내드립니다.<br>
                                                    YBM스마트스쿨 회원 여러분의 개인정보 보호를 위하여 일정기간 이용하지 않는 회원의 경우 다음과 같이 조치하고 있습니다.
                                                </td>
                                            </tr>
                                            <tr><td style="height:33px"></td></tr>

                                            <tr>
                                                <td>
                                                    <table border="0" cellpadding="0" cellspacing="0" style="width:100%; border: 1px solid #ffffff;">
                                                        <tr>
                                                            <td style="background-color: #E6E6E6;color:#000000;font-size:15px;padding:10px;">
                                                                - 1년 이상 미로그인 시 : 휴면계정으로 분리하여 저장·관리 (1년 이내 재로그인 시 휴면 해제 가능)
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td style="background-color: #E6E6E6;color:#000000;font-size:15px;padding:10px;border-top:1px solid #ffffff;">
                                                                - 2년 이상 미로그인 시 : 별도 고지 없이 회원 탈퇴 및 개인정보 파기
                                                            </td>
                                                        </tr>
                                                    </table>
                                                </td>
                                            </tr>
                                            
                                            
                                            <tr><td style="height:18px"></td></tr>
                                            <tr>
                                                <td style="color:#000000;font-size: 18px;font-weight: 400;line-height: 26px;">
                                                    따라서 본 이메일을 수신하시는 회원님께서는 휴면계정 전환 대상에 해당되오니 아래 내용을 꼭 확인하시어 홈페이지 이용에 불편이 없도록 유의하시기 바랍니다.
                                                </td>
                                            </tr>
                                            <tr><td style="height:30px"></td></tr>
                                            <tr>
                                                <td>                                            
                                                    <p style="color: #EA7D3C;font-size: 16px;font-weight: 700;line-height: 23px;margin:0;">1. 주요내용</p>                                                    
                                                    <p style="font-size: 16px;font-weight: 400;line-height: 23px;margin:8px 0 20px 23px;">YBM스마트스쿨 홈페이지를 1년 이상 이용하지 않은 회원의 경우 휴면계정으로 분리하여 별도 저장·관리</p>

                                                    <p style="color: #EA7D3C;font-size: 16px;font-weight: 700;line-height: 23px;margin:0;">2. 휴면계정으로 분리되는 개인정보 항목</p>                                                    
                                                    <p style="font-size: 16px;font-weight: 400;line-height: 23px;margin:8px 0 20px 23px;">회원가입 시 수집한 모든 개인정보</p>
                                                    <p style="color: #EA7D3C;font-size: 16px;font-weight: 700;line-height: 23px;margin:0;">3. 시행일자</p>
                                                    <p style="font-size: 16px;font-weight: 400;line-height: 23px;margin:8px 0 0 23px;">#{inactiveTargetDate}</p>
                                                </td>
                                            </tr>
                                            <tr><td style="height:30px"></td></tr>
                                            <tr>
                                                <td style="color:#000000;font-size: 18px;font-weight: 400;line-height: 26px;">
                                                    위 시행일 이후에는 별도의 절차에 따라 휴면계정을 해제하기 전까지 홈페이지를 이용할 수 없는 상태가 되며,<br>
                                                    SMS 또는 이메일 수신동의를 하셨더라도 이벤트 및 기타 서비스 안내 등을 받으실 수 없습니다.<br><br>                                                    
                                                    회원님께서 휴면계정 전환 없이 홈페이지를 계속 이용하시려면 위 시행일 이전에 홈페이지에 접속하여<br>
                                                    1회 이상 로그인하여 주시기 바랍니다.<br><br>
                                                    이를 원치 않으실 경우 언제든지 탈퇴하실 수 있습니다. &nbsp;&nbsp;
                                                    <a href="https://www.ybmsmartschool.com/myInfo/confirm_passwd?originalUrl=/myInfo/withdraw" style="color:#3F6CE0;font-size: 18px;font-weight: 400;line-height: 26px;"  target="_blank" rel="noreferrer noopener">&gt;&gt;탈퇴 바로가기</a><br><br>
                                                    감사합니다.
                                                </td>
                                            </tr>                                            
                                            <tr><td style="height:60px"></td></tr>
                                            <tr>
                                                <td>
            <p style="display: flex; align-items: center; line-height:50px; height: 50px; width: 300px; margin: 0 auto;"><a href="https://ybmsmartschool.com/login" target="_blank" style="font-size:18px;font-family:Arial;color:#FFFFFF;font-weight:bold;font-style:normal;  border:none; background: #ED7D31; border-radius: 5px;text-align: center; width:300px; text-decoration: none; ">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;로그인 하기&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</a></p>
                                                </td>
                                            </tr>
                                            <tr><td style="height:60px"></td></tr>
                                            
                                            <tr>
                                                <td>
                                                    <ul style="font-size: 16px;font-weight: 400;line-height: 23px;color: #707070;margin:0;">
                                                        <li>본 이메일은 발송되기 직전에 이미 로그인하신 일부 회원님께도 발송되었을 수 있으니 양해바랍니다.</li>
                                                        <li>본 메일은 발신전용 메일로 회신이 되지 않습니다. 문의사항은 홈페이지 내 고객센터를 이용해 주시기 바랍니다.</li>
                                                    </ul>
                                                </td>
                                            </tr>
                                            <tr><td style="height:30px"></td></tr>
                                        </tbody>
                                    </table>
                                </td>
                                <!--<td style="width:40px"></td>-->
                            </tr>
                            
                        </tbody> 
                    </table> 
                </td>
            </tr>
        </tbody>
    </table>
    
    <table border="0" cellpadding="0" cellspacing="0" style="width:1000px;background-color: #F1F1F1; "> 
        <tr>
            <td style="padding:40px 40px 35px 40px;font-family:'Noto Sans KR','나눔고딕',NanumGothic,'맑은 고딕', SDNeoGothic, SDGothicNeo, '돋움', 'dotum', sans-serif;""> 
                <p style="color: #707070;font-size: 16px;font-weight: 500;line-height: 23px;margin:0;">㈜와이비엠 서울시 종로구 종로 104 대표이사 허문호, 정용환 사업자등록번호 101-81-14655</p>
                <p style="color: #707070;font-size: 16px;font-weight: 400;line-height: 23px;margin:0;margin-top:10px;">
                고객센터 : 02-2000-0599 FAX : 02-2000-0426 E-mail : smartschool@ybm.co.kr<br>
                Copyright ⓒ (주)와이비엠. All rights reserved.</p>
            </td>
        </tr>
    </table>
        
</body>
</html>
    `;
    } else if (page.emailFormat == 'email_ad') {
      info.msg = `
      <!DOCTYPE html>
<html lang="ko">
<head>
<meta charset="utf-8">
<title>스마트스쿨</title>
</head>
<body>
    <table border="0" cellpadding="0" cellspacing="0" style="width:1000px;background-color:#fff;"> 
        <tbody>
            <tr>
                <td style="border-top:15px solid #EA7D3C"></td>
            </tr>
            <tr>
                <td style="height:30px;"></td>
            </tr>
            <tr>
                <td style="padding:0 40px;font-family:'Noto Sans KR','나눔고딕',NanumGothic,'맑은 고딕', SDNeoGothic, SDGothicNeo, '돋움', 'dotum', sans-serif;""> 
                    <table border="0" cellpadding="0" cellspacing="0" style="width:100%"> 
                        <tbody>
                            <tr>                                            
                                <!--<td style="width:40px"></td>-->
                                <td>
                                    <table border="0" cellpadding="0" cellspacing="0" style="width:100%"> 
                                        <tbody>
                                            <tr>
                                                <td>
                                                    <table border="0" cellpadding="0" cellspacing="0" style="width:100%"> 
                                                        <tbody>
                                                            <tr>

                                                                <td align="left" style="height:16px;margin:0;padding:0;vertical-align:top;font-size:0;line-height:0"> 
                                                                    <img src="https://www.ybmsmartschool.com/membership/img/mail_logo2.png" style="width:143px;height:48px;vertical-align:top;border:0;" loading="lazy">                                                 
                                                                </td>  
                                                    
                                                                <td align="right">
                                                                    <table border="0" cellpadding="0" cellspacing="0" style="width:125px"> 
                                                                        <tbody>
                                                                            <tr>
                                                                                <td>
                                                                                    <a href="https://www.ybmsmartschool.com/"  target="_blank" rel="noreferrer noopener" ><img border="0" src="https://www.ybmsmartschool.com/membership/img/mail_home2.png" alt="홈" loading="lazy"></a>
                                                                                    
                                                                                </td>
                                                                                <td  width="30"></td>
                                                                                <td style="height:48px;">
                                                                                    <a href="https://www.ybmsmartschool.com/notice/list"  target="_blank" rel="noreferrer noopener" ><img border="0" src="https://www.ybmsmartschool.com/membership/img/mail_custom2.png" alt="고객센터" loading="lazy"></a>
                                                                                </td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </table>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>                                                                
                                                </td>
                                            </tr>
                                            <tr><td style="height:56px"></td></tr>
                                            <tr>
                                                <td><span style="color:#000000;font-size: 24px;font-weight: 400;line-height: 35px;letter-spacing: -0.05em;text-align: left;"">YBM스마트스쿨</span><br>
                                                    <span style="color:#000000;font-size: 40px;font-weight: 700;line-height: 58px;letter-spacing: -0.05em;text-align: left;">광고성 정보 수신 여부 안내</span>
                                                </td>
                                            </tr>
                                            <tr><td style="height:43px"></td></tr>
                                            <tr>
                                                <td style="color:#000000;font-size: 18px;font-weight: 400;line-height: 26px;">
                                                    안녕하세요, YBM스마트스쿨입니다.<br>
                                                    정보통신망 이용촉진 및 정보보호 등에 관한 법률 제 50조 및 동 시행령 제 62조 3에 의거하여<br>
                                                    YBM스마트스쿨 회원님의 광고성 정보 수신 동의 여부에 대해 다음과 같이 안내드립니다.
                                                </td>
                                            </tr>
                                            <tr><td style="height:50px"></td></tr>
                                            <tr>
                                                <td style="color:#000000;font-size: 18px;font-weight: 700;line-height: 26px;">회원님의 마케팅 수신여부</td>
                                            </tr>
                                            <tr><td style="height:14px"></td></tr>
                                            <tr>
                                                <td>
                                                    <table border="0" cellpadding="0" cellspacing="0" style="width:100%; border: 1px solid #ffffff;">
                                                        <thead>
                                                            <tr style="height: 40px;">
                                                                <th style="background-color: #BABABA; color: #ffffff; font-size:15px;text-align: center;border: 1px solid #ffffff;">정보전송자</th>
                                                                <th style="background-color: #BABABA; color: #ffffff; font-size:15px;text-align: center;border: 1px solid #ffffff;">동의 항목</th>
                                                                <th style="background-color: #BABABA; color: #ffffff; font-size:15px;text-align: center;border: 1px solid #ffffff;">동의 여부</th>
                                                                <th style="background-color: #BABABA; color: #ffffff; font-size:15px;text-align: center;border: 1px solid #ffffff;">동의 날짜</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr style="height: 40px;">
                                                                <td style="background-color: #E6E6E6; color:#000000;font-size:15px;text-align: center;border: 1px solid #ffffff;" rowspan="2">YBM스마트스쿨</td>
                                                                <td style="background-color: #E6E6E6; color:#000000;font-size:15px;text-align: center;border: 1px solid #ffffff;">SMS</td>
                                                                <td style="background-color: #E6E6E6; color:#000000;font-size:15px;text-align: center;border: 1px solid #ffffff;">#{smsYn}</td>
                                                                <td style="background-color: #E6E6E6; color:#000000;font-size:15px;text-align: center;border: 1px solid #ffffff;">#{smsAcceptDate}</td>
                                                            </tr>
                                                            <tr style="height: 40px;">
                                                                <td style="background-color: #E6E6E6; color:#000000;font-size:15px;text-align: center;border: 1px solid #ffffff;">이메일</td>
                                                                <td style="background-color: #E6E6E6; color:#000000;font-size:15px;text-align: center;border: 1px solid #ffffff;">#{emailYn}</td>
                                                                <td style="background-color: #E6E6E6; color:#000000;font-size:15px;text-align: center;border: 1px solid #ffffff;">#{emailAcceptDate}</td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </td>
                                            </tr>
                                            <tr><td style="height:14px"></td></tr>
                                            <tr>
                                                <td style="color:#707070;font-size: 14px;font-weight: 400;line-height: 20px;">※ 위 수신 동의 내용은 #{targetDate} 기준 정보로 작성되었으며, 이후에 상태를 변경하신 경우에는 안내 내용과 다를 수 있습니다.</td>
                                            </tr>
                                            <tr><td style="height:30px"></td></tr>
                                            <tr>
                                                <td style="font-weight: 700;font-size: 16px;line-height: 23px;color: #000000;">수신동의 설정 변경 방법</td>
                                            </tr>
                                            <tr>
                                                <td style="font-weight: 400;font-size: 16px;line-height: 23px;color: #000000;">YBM스마트스쿨 개인정보관리 &gt; 회원정보변경 &gt; 마케팅정보 수신 &gt; 이메일/SMS 수신여부 체크</td>
                                            </tr>
                                            <tr><td style="height:45px"></td></tr>
                                            <tr>
                                                <td>
			<p style="display: flex; align-items: center; line-height:50px; height: 50px; width: 300px; margin: 0 auto;"><a href="https://www.ybmsmartschool.com/myInfo/modify_user_info" style="font-size:18px;font-family:Arial;color:#FFFFFF;font-weight:bold;font-style:normal;  border:none; background: #ED7D31; border-radius: 5px;text-align: center; width:300px; text-decoration: none;" target="_blank">&nbsp;&nbsp;&nbsp;&nbsp;수신 동의 설정 변경하기&nbsp;&nbsp;&nbsp;&nbsp;</a></p>
                                                </td>
                                            </tr>
                                            <tr><td style="height:60px"></td></tr>
                                            <tr>
                                                <td>
                                                    <ul style="font-size: 16px;font-weight: 400;line-height: 23px;color: #707070;margin:0;">
                                                        <li>본 메일은 정보통신망이용촉진 및 정보보호 등에 관한 법률 및 시행규칙을 준수한 발신전용 메일입니다.</li>
                                                        <li>본 메일은 발신전용 메일로 회신이 되지 않습니다. 문의사항은 홈페이지 내 고객센터를 이용해 주시기 바랍니다.</li>
                                                    </ul>
                                                </td>
                                            </tr>
                                            <tr><td style="height:30px"></td></tr>
                                        </tbody>
                                    </table>
                                </td>
                                <!--<td style="width:40px"></td>-->
                            </tr>
                            
                        </tbody> 
                    </table> 
                </td>
            </tr>
        </tbody>
    </table>
    
    <table border="0" cellpadding="0" cellspacing="0" style="width:1000px;background-color: #F1F1F1; "> 
        <tr>
            <td style="padding:40px 40px 35px 40px;font-family:'Noto Sans KR','나눔고딕',NanumGothic,'맑은 고딕', SDNeoGothic, SDGothicNeo, '돋움', 'dotum', sans-serif;""> 
                <p style="color: #707070;font-size: 16px;font-weight: 500;line-height: 23px;margin:0;">㈜와이비엠 서울시 종로구 종로 104 대표이사 허문호, 정용환 사업자등록번호 101-81-14655</p>
                <p style="color: #707070;font-size: 16px;font-weight: 400;line-height: 23px;margin:0;margin-top:10px;">
                고객센터 : 02-2000-0599 FAX : 02-2000-0426 E-mail : smartschool@ybm.co.kr<br>
                Copyright ⓒ (주)와이비엠. All rights reserved.</p>
            </td>
        </tr>
    </table>
        
</body>
</html>
      `;
    } else if (page.emailFormat == 'email_ad_all') {
      info.msg = `
      <!DOCTYPE html>
<html lang="ko">
<head>
<meta charset="utf-8">
<title>스마트스쿨</title>
</head>
<body>
    <table border="0" cellpadding="0" cellspacing="0" style="width:1000px;background-color:#fff;"> 
        <tbody>
            <tr>
                <td style="border-top:15px solid #EA7D3C"></td>
            </tr>
            <tr>
                <td style="height:30px;"></td>
            </tr>
            <tr>
                <td style="padding:0 40px;font-family:'Noto Sans KR','나눔고딕',NanumGothic,'맑은 고딕', SDNeoGothic, SDGothicNeo, '돋움', 'dotum', sans-serif;""> 
                    <table border="0" cellpadding="0" cellspacing="0" style="width:100%"> 
                        <tbody>
                            <tr>                                            
                                <!--<td style="width:40px"></td>-->
                                <td>
                                    <table border="0" cellpadding="0" cellspacing="0" style="width:100%"> 
                                        <tbody>
                                            <tr>
                                                <td>
                                                    <table border="0" cellpadding="0" cellspacing="0" style="width:100%"> 
                                                        <tbody>
                                                            <tr>

                                                                <td align="left" style="height:16px;margin:0;padding:0;vertical-align:top;font-size:0;line-height:0"> 
                                                                    <img src="https://www.ybmsmartschool.com/membership/img/mail_logo2.png" style="width:143px;height:48px;vertical-align:top;border:0;" loading="lazy">                                                 
                                                                </td>  
                                                    
                                                                <td align="right">
                                                                    <table border="0" cellpadding="0" cellspacing="0" style="width:125px"> 
                                                                        <tbody>
                                                                            <tr>
                                                                                <td>
                                                                                    <a href="https://www.ybmsmartschool.com/"  target="_blank" rel="noreferrer noopener" ><img border="0" src="https://www.ybmsmartschool.com/membership/img/mail_home2.png" alt="홈" loading="lazy"></a>
                                                                                    
                                                                                </td>
                                                                                <td  width="30"></td>
                                                                                <td style="height:48px;">
                                                                                    <a href="https://www.ybmsmartschool.com/notice/list"  target="_blank" rel="noreferrer noopener" ><img border="0" src="https://www.ybmsmartschool.com/membership/img/mail_custom2.png" alt="고객센터" loading="lazy"></a>
                                                                                </td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </table>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>                                                                
                                                </td>
                                            </tr>
                                            <tr><td style="height:56px"></td></tr>
                                            <tr>
                                                <td><span style="color:#000000;font-size: 24px;font-weight: 400;line-height: 35px;letter-spacing: -0.05em;text-align: left;"">YBM스마트스쿨</span><br>
                                                    <span style="color:#000000;font-size: 40px;font-weight: 700;line-height: 58px;letter-spacing: -0.05em;text-align: left;">광고성 정보 수신 여부 안내</span>
                                                </td>
                                            </tr>
                                            <tr><td style="height:43px"></td></tr>
                                            <tr>
                                                <td style="color:#000000;font-size: 18px;font-weight: 400;line-height: 26px;">
                                                    안녕하세요, YBM스마트스쿨입니다.<br>
                                                    정보통신망 이용촉진 및 정보보호 등에 관한 법률 제 50조 및 동 시행령 제 62조 3에 의거하여<br>
                                                    YBM스마트스쿨 회원님의 광고성 정보 수신 동의 여부에 대해 다음과 같이 안내드립니다.
                                                </td>
                                            </tr>
                                            <tr><td style="height:50px"></td></tr>
                                            <tr>
                                                <td style="color:#000000;font-size: 18px;font-weight: 700;line-height: 26px;">회원님의 마케팅 수신여부</td>
                                            </tr>
                                            <tr><td style="height:14px"></td></tr>
                                            <tr>
                                                <td>
                                                    <table border="0" cellpadding="0" cellspacing="0" style="width:100%; border: 1px solid #ffffff;">
                                                        <thead>
                                                            <tr style="height: 40px;">
                                                                <th style="background-color: #BABABA; color: #ffffff; font-size:15px;text-align: center;border: 1px solid #ffffff;">정보전송자</th>
                                                                <th style="background-color: #BABABA; color: #ffffff; font-size:15px;text-align: center;border: 1px solid #ffffff;">동의 항목</th>
                                                                <th style="background-color: #BABABA; color: #ffffff; font-size:15px;text-align: center;border: 1px solid #ffffff;">동의 여부</th>
                                                                <th style="background-color: #BABABA; color: #ffffff; font-size:15px;text-align: center;border: 1px solid #ffffff;">동의 날짜</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr style="height: 40px;">
                                                                <td style="background-color: #E6E6E6; color:#000000;font-size:15px;text-align: center;border: 1px solid #ffffff;" rowspan="2">YBM스마트스쿨</td>
                                                                <td style="background-color: #E6E6E6; color:#000000;font-size:15px;text-align: center;border: 1px solid #ffffff;">SMS</td>
                                                                <td style="background-color: #E6E6E6; color:#000000;font-size:15px;text-align: center;border: 1px solid #ffffff;">#{smsYn}</td>
                                                                <td style="background-color: #E6E6E6; color:#000000;font-size:15px;text-align: center;border: 1px solid #ffffff;">#{smsAcceptDate}</td>
                                                            </tr>
                                                            <tr style="height: 40px;">
                                                                <td style="background-color: #E6E6E6; color:#000000;font-size:15px;text-align: center;border: 1px solid #ffffff;">이메일</td>
                                                                <td style="background-color: #E6E6E6; color:#000000;font-size:15px;text-align: center;border: 1px solid #ffffff;">#{emailYn}</td>
                                                                <td style="background-color: #E6E6E6; color:#000000;font-size:15px;text-align: center;border: 1px solid #ffffff;">#{emailAcceptDate}</td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </td>
                                            </tr>
                                            <tr><td style="height:14px"></td></tr>
                                            <tr>
                                                <td style="color:#707070;font-size: 14px;font-weight: 400;line-height: 20px;">※ 위 수신 동의 내용은 #{targetDate} 기준 정보로 작성되었으며, 이후에 상태를 변경하신 경우에는 안내 내용과 다를 수 있습니다.</td>
                                            </tr>
                                            <tr><td style="height:30px"></td></tr>
                                            <tr>
                                                <td style="font-weight: 700;font-size: 16px;line-height: 23px;color: #000000;">수신동의 설정 변경 방법</td>
                                            </tr>
                                            <tr>
                                                <td style="font-weight: 400;font-size: 16px;line-height: 23px;color: #000000;">YBM스마트스쿨 개인정보관리 &gt; 회원정보변경 &gt; 마케팅정보 수신 &gt; 이메일/SMS 수신여부 체크</td>
                                            </tr>
                                            <tr><td style="height:45px"></td></tr>
                                            <tr>
                                                <td>
			<p style="display: flex; align-items: center; line-height:50px; height: 50px; width: 300px; margin: 0 auto;"><a href="https://www.ybmsmartschool.com/myInfo/modify_user_info" style="font-size:18px;font-family:Arial;color:#FFFFFF;font-weight:bold;font-style:normal;  border:none; background: #ED7D31; border-radius: 5px;text-align: center; width:300px; text-decoration: none;" target="_blank">&nbsp;&nbsp;&nbsp;&nbsp;수신 동의 설정 변경하기&nbsp;&nbsp;&nbsp;&nbsp;</a></p>
                                                </td>
                                            </tr>
                                            <tr><td style="height:60px"></td></tr>
                                            <tr>
                                                <td>
                                                    <ul style="font-size: 16px;font-weight: 400;line-height: 23px;color: #707070;margin:0;">
                                                        <li>본 메일은 정보통신망이용촉진 및 정보보호 등에 관한 법률 및 시행규칙을 준수한 발신전용 메일입니다.</li>
                                                        <li>본 메일은 발신전용 메일로 회신이 되지 않습니다. 문의사항은 홈페이지 내 고객센터를 이용해 주시기 바랍니다.</li>
                                                    </ul>
                                                </td>
                                            </tr>
                                            <tr><td style="height:30px"></td></tr>
                                        </tbody>
                                    </table>
                                </td>
                                <!--<td style="width:40px"></td>-->
                            </tr>
                            
                        </tbody> 
                    </table> 
                </td>
            </tr>
        </tbody>
    </table>
    
    <table border="0" cellpadding="0" cellspacing="0" style="width:1000px;background-color: #F1F1F1; "> 
        <tr>
            <td style="padding:40px 40px 35px 40px;font-family:'Noto Sans KR','나눔고딕',NanumGothic,'맑은 고딕', SDNeoGothic, SDGothicNeo, '돋움', 'dotum', sans-serif;""> 
                <p style="color: #707070;font-size: 16px;font-weight: 500;line-height: 23px;margin:0;">㈜와이비엠 서울시 종로구 종로 104 대표이사 허문호, 정용환 사업자등록번호 101-81-14655</p>
                <p style="color: #707070;font-size: 16px;font-weight: 400;line-height: 23px;margin:0;margin-top:10px;">
                고객센터 : 02-2000-0599 FAX : 02-2000-0426 E-mail : smartschool@ybm.co.kr<br>
                Copyright ⓒ (주)와이비엠. All rights reserved.</p>
            </td>
        </tr>
    </table>
        
</body>
</html>
      `;
    } else if (page.emailFormat == 'email_privacy') {
      info.msg = `
      <!DOCTYPE html>
<html lang="ko">
<head>
<meta charset="utf-8">
<title>스마트스쿨</title>
</head>
<body>
    <table border="0" cellpadding="0" cellspacing="0" style="width:1000px;background-color:#fff;"> 
        <tbody>
            <tr>
                <td style="border-top:15px solid #EA7D3C"></td>
            </tr>
            <tr>
                <td style="height:30px;"></td>
            </tr>
            <tr>
                <td style="padding:0 40px;font-family:'Noto Sans KR','나눔고딕',NanumGothic,'맑은 고딕', SDNeoGothic, SDGothicNeo, '돋움', 'dotum', sans-serif;""> 
                    <table border="0" cellpadding="0" cellspacing="0" style="width:100%"> 
                        <tbody>
                            <tr>                                            
                                <!--<td style="width:40px"></td>-->
                                <td>
                                    <table border="0" cellpadding="0" cellspacing="0" style="width:100%"> 
                                        <tbody>
                                            <tr>
                                                <td>
                                                    <table border="0" cellpadding="0" cellspacing="0" style="width:100%"> 
                                                        <tbody>
                                                            <tr>

                                                                <td align="left" style="height:16px;margin:0;padding:0;vertical-align:top;font-size:0;line-height:0"> 
                                                                    <img src="https://www.ybmsmartschool.com/membership/img/mail_logo2.png" style="width:143px;height:48px;vertical-align:top;border:0;" loading="lazy">                                                 
                                                                </td>  
                                                    
                                                                <td align="right">
                                                                    <table border="0" cellpadding="0" cellspacing="0" style="width:125px"> 
                                                                        <tbody>
                                                                            <tr>
                                                                                <td>
                                                                                    <a href="https://www.ybmsmartschool.com/"  target="_blank" rel="noreferrer noopener" ><img border="0" src="https://www.ybmsmartschool.com/membership/img/mail_home2.png" alt="홈" loading="lazy"></a>
                                                                                    
                                                                                </td>
                                                                                <td  width="30"></td>
                                                                                <td style="height:48px;">
                                                                                    <a href="https://www.ybmsmartschool.com/notice/list"  target="_blank" rel="noreferrer noopener" ><img border="0" src="https://www.ybmsmartschool.com/membership/img/mail_custom2.png" alt="고객센터" loading="lazy"></a>
                                                                                </td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </table>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>                                                                
                                                </td>
                                            </tr>
                                            <tr><td style="height:56px"></td></tr>
                                            <tr>
                                                <td><span style="color:#000000;font-size: 24px;font-weight: 400;line-height: 35px;letter-spacing: -0.05em;text-align: left;"">YBM스마트스쿨</span><br>
                                                    <span style="color:#000000;font-size: 40px;font-weight: 700;line-height: 58px;letter-spacing: -0.05em;text-align: left;">개인정보 이용 내역 안내</span> 
                                            </tr>
                                            <tr><td style="height:43px"></td></tr>
                                            <tr>
                                                <td style="color:#000000;font-size: 18px;font-weight: 400;line-height: 26px;">
                                                    안녕하세요, YBM스마트스쿨입니다.<br>
                                                    항상 YBM스마트스쿨을 이용해 주시는 회원 여러분께 진심으로 감사드립니다.<br><br>
                                                    “개인정보보호법 제39조의 8(개인정보 이용내역의 통지)”에 의거하여,<br>
                                                    이메일 수신동의 여부와 관계없이 연 1회 전 회원 여러분께 안내해 드리오니 서비스 이용에 참고하시기 바랍니다.<br><br>
                                                    상세한 개인정보 이용내역은 아래 “개인정보처리방침 원문 보기”를 통해 확인하실 수 있습니다.
                                                </td>
                                            </tr>
                                            <tr><td style="height:60px"></td></tr>
                                            <tr>
                                                <td>
			<p style="display: flex; align-items: center; line-height:50px; height: 50px; width: 300px; margin: 0 auto;"><a href="https://www.ybmsmartschool.com/?popup=personal" style="font-size:18px;font-family:Arial;color:#FFFFFF;font-weight:bold;font-style:normal;  border:none; background: #ED7D31; border-radius: 5px;text-align: center; width:300px; text-decoration: none;" target="_blank">&nbsp;&nbsp;개인정보처리방침 원문 보기&nbsp;&nbsp;</a></p>
                                                </td>
                                            </tr>
                                            <tr><td style="height:60px"></td></tr>
                                            <tr>
                                                <td style="color:#000000;font-size: 18px;font-weight: 400;line-height: 26px;">
                                                    YBM스마트스쿨은 회원 여러분의 개인정보를 소중히 여기고,<br>
                                                    관련 법규에 따라 안전하게 보호하고 있습니다.<br><br>
                                                    감사합니다.
                                                </td>
                                            </tr>                                            
                                            <tr><td style="height:60px"></td></tr>
                                            <tr>
                                                <td>
                                                    <ul style="font-size: 16px;font-weight: 400;line-height: 23px;color: #707070;margin:0;">
                                                        <li>본 메일은 정보통신망이용촉진 및 정보보호 등에 관한 법률 및 시행규칙을 준수한 발신전용 메일입니다.</li>
                                                        <li>본 메일은 발신전용 메일로 회신이 되지 않습니다. 문의사항은 홈페이지 내 고객센터를 이용해 주시기 바랍니다.</li>
                                                    </ul>
                                                </td>
                                            </tr>
                                            <tr><td style="height:30px"></td></tr>
                                        </tbody>
                                    </table>
                                </td>
                                <!--<td style="width:40px"></td>-->
                            </tr>
                            
                        </tbody> 
                    </table> 
                </td>
            </tr>
        </tbody>
    </table>
    
    <table border="0" cellpadding="0" cellspacing="0" style="width:1000px;background-color: #F1F1F1; "> 
        <tr>
            <td style="padding:40px 40px 35px 40px;font-family:'Noto Sans KR','나눔고딕',NanumGothic,'맑은 고딕', SDNeoGothic, SDGothicNeo, '돋움', 'dotum', sans-serif;""> 
                <p style="color: #707070;font-size: 16px;font-weight: 500;line-height: 23px;margin:0;">㈜와이비엠 서울시 종로구 종로 104 대표이사 허문호, 정용환 사업자등록번호 101-81-14655</p>
                <p style="color: #707070;font-size: 16px;font-weight: 400;line-height: 23px;margin:0;margin-top:10px;">
                고객센터 : 02-2000-0599 FAX : 02-2000-0426 E-mail : smartschool@ybm.co.kr<br>
                Copyright ⓒ (주)와이비엠. All rights reserved.</p>
            </td>
        </tr>
    </table>
        
</body>
</html>
      `;
    }
  }

  function openMemberSearchPopup() {
    page.showMemberSearchPopup = true;
  }

  function closeMemberSearchPopup() {
    page.showMemberSearchPopup = false;
  }

  function downloadTemplate() {
    const messageTemplateUrl = '/excel/메시지발송샘플.xlsx';
    downloadUrl(messageTemplateUrl);
  }

  // 엑셀파일로 임시 목록에 추가
  function addToTempMembersExcel() {
    console.log('addToTempMembersExcel, ', event);
    const fileInput = this.$refs.fileInput;
    fileInput.click();
  }

  async function readTempMembersExcel(event) {
    console.log('readTempMembersExcel, ', event);

    // get File object from input tag
    const file = event.target.files[0]; 
    if (!file) {
      return;
    }
    const fileName = file.name; 
    const reader = new FileReader(); 

    // if you use "this", don't use "function(e) {...}" 
    reader.onload = async (e) => { 
      let data = e.target.result; 
      data = new Uint8Array(data); 
      // get excel file 
      const excelFile = Xlsx.read(data, { type: "array" });

      if (excelFile.SheetNames.length > 0) {
        const firstSheetName = excelFile.SheetNames[0];
        const firstSheet = excelFile.Sheets[firstSheetName];
        const roa = Xlsx.utils.sheet_to_json(firstSheet, /*{header:1}*/);
        if (roa.length) {
          const addList = roa.map((item) => {
            return {'loginId':item['회원ID'], 'name':item['이름'], 'phone':item['휴대폰번호'], 'email':item['이메일주소']}
          });
          console.log('addList:', addList);

          this.modalLoading = true;
          // 회원 아이디가 있는 경우, 회원 아이디로 검색한 결과 추가
          const userIdList = addList.filter((user) => user.loginId).map((user) => user.loginId);
          const params = {
            page:1,
            limit:999999,
            loginIdList:userIdList.join(',')
          }
          const result = await memberApi.getUserList(params);
          this.addToTempMembers(result.data);

          // 회원 아이디가 없는 경우, 이름/휴대폰/이메일 정보 추가
          const noMemberList = addList.filter((user) => !user.loginId && user.name && user.phone && user.email);
          noMemberList.forEach((noMember) => {
            this.addNoMember(null, noMember);
          })
          this.searchTemp();
          this.modalLoading = false;
        }
      }
    }; 
    reader.readAsArrayBuffer(file);
    event.target.value = '';
  }  

  // 발송대상 임시 목록에 추가
  function addToTempMembers(selectedMembers) {
    page.showMemberSearchPopup = false;
    console.log('selectedMembers:', selectedMembers);

    const tempMemberIds = data.totalMembers.map((user) => user.loginId);
    const filteredMembers = selectedMembers.filter((user) => !tempMemberIds.includes(user.loginId));
    // data.totalMembers.unshift(...filteredMembers);
    // unshiftPop(data.totalMembers, filteredMembers);
    data.totalMembers = filteredMembers.concat(data.totalMembers);

    this.searchTemp();
  }

  // 비회원(폰번호 또는 이메일)을 발송대상 임시 목록에 추가
  async function addNoMember(addType, noMember) {
    if (!noMember) {
      const isValid = await this.$validator.validateAll(addType);
      if (!isValid) {
        //console.log('errors:', this.errors);
        alert('필수 입력 항목을 확인해주세요.');
        return;
      }
    }
    
    const name = noMember ? noMember.name : data.noMember.name;
    const phone = noMember ? noMember.phone :data.noMember.phone;
    const email = noMember ? noMember.email :data.noMember.email;
    //console.log('name,phone,email:', name,phone,email);

    const user = {
      loginId : '', // 비회원
      noMemberId : '', // 비회원 구분자, 폰번호 또는 이메일을 구분자로 사용한다.
      name: name,
      phone : '',
      email : '',
      smsYn : '',
      emailYn : '',
      forceSendYn : ''
    }
    if (!noMember && info.sendTypeCd == '318002') {
      user.phone = phone;
      user.noMemberId = phone;
      const isDuplicated = data.totalMembers.find((item) => item.phone == phone);
      if (isDuplicated) {
        alert('중복된 번호가 이미 있습니다.');
        return;
      }
    } else if (!noMember && info.sendTypeCd == '318001') {
      user.email = email;
      user.noMemberId = email;
      const isDuplicated = data.totalMembers.find((item) => item.email == email);
      if (isDuplicated) {
        alert('중복된 이메일이 이미 있습니다.');
        return;
      }
    } else if (noMember) {
      // 파일로 읽는 경우 phone, email 은 모두 존재해야 한다.(필수)
      user.phone = phone;
      user.email = email;
      user.noMemberId = `${phone}_${email}`;
      const isDuplicated = data.totalMembers.find((item) => item.noMemberId == user.noMemberId);
      if (isDuplicated) {
        return;
      }
    }
    
    data.totalMembers.unshift(user);

    if (!noMember) {
      // 하나씩 입력한 경우
      this.searchTemp();
    }
  }

  // 발송대상 임시 목록에서 삭제
  function removeFromTempMembers(loginId, noMemberId) {
    if (noMemberId) {
      const filteredMembers = data.totalMembers.filter((user) => user.noMemberId != noMemberId);
      data.totalMembers = filteredMembers;
    } else if (loginId) {
      const filteredMembers = data.totalMembers.filter((user) => user.loginId != loginId);
      data.totalMembers = filteredMembers;
    }

    this.searchTemp();
  }

  // 기본정보 저장 & 발송대상 선택 화면 보여줌
  async function saveAndShowMessageTarget() {
    const isValid = await this.$validator.validateAll('edit');
    if (!isValid) {
      // froala editor는 tag부분만 validator가 작동하고, view 부분은 작동이 안되서 수동으로 설정.
      let editor = $('#jodit_edit');
      if (editor) {
        if (this.errors.has('edit.msgEmail')) {
          $(editor).prev().attr("data-v-eef1eb36" , true);
          $(editor).prev().addClass('is-invalid');
        } else {
          $(editor).prev().removeClass('is-invalid');
        }
      }

      // console.log('save errors:', this.errors);
      //console.log('info:', info);
      alert('필수 입력 항목을 확인해주세요.');
      return;
    }

    // 기본 정보 저장
    let params = {};
    for (const property in info) {
      if (property == 'schDt') {
        const sendDate = moment(page.sendDate).format("YYYY-MM-DD");
        const schDt = `${sendDate} ${page.sendTime}`;
        params[property] = schDt;
      } else {
        params[property] = info[property];
      }
    }

    console.log('saveMessage, params:', params);

    this.modalLoading = true;
    const result = await messageApi.saveMessage(params);
    if (result.data && !isNaN(result.data)) {
      // 신규 등록일 경우 msgSeq 수정
      info.msgSeq = result.data;
    }

    // updId, updDt 를 업데이트하기 위해 detail 을 새로 읽어온다.
    this.detail();

    this.modalLoading = false;

    // 임시목록 초기화
    data.totalMembers.splice(0, data.totalMembers.length);

    // 발송대상 보여줌, 유형 disalbe 처리
    page.msgSelectTypeCd = info.msgSelectTypeCd;
  }

  // 발송대상 목록에 추가하고 서버에 전송
  async function saveWithSendMembers() {
    /*const isValid = await this.$validator.validateAll('edit');
    if (!isValid) {
      alert('필수 입력 항목을 확인해주세요.');
      return;
    }*/
    if (!confirm('발송대상에 등록하고 서버에 반영하시겠습니까?')) {
      return;
    }

    // 임시 목록을 발송대상에 추가
    const sendMemberIds = sendData.totalMembers.map((user) => user.loginId);
    const filteredMembers = data.totalMembers.filter((user) => !sendMemberIds.includes(user.loginId));
    filteredMembers.forEach((user) => {
      user.forceSendYn = page.forceSendYn;
    })
    if (filteredMembers.length == 0) {
      alert('발송대상에 등록할 사용자가 없습니다.');
      return;
    }

    // 발송대상 서버에 저장
    this.modalLoading = true;
    const chunk_size = 1000;
    for (let idx = 0; idx < filteredMembers.length; idx += chunk_size) {
      const paramList = filteredMembers.slice(idx, idx+chunk_size).map((user) => {
        const param = {};
        param.msgSeq = info.msgSeq;
        param.loginId = user.loginId;
        param.name = user.name;
        param.phone = user.phone;
        param.email = user.email;
        param.forceSendYn = user.forceSendYn;
        return param;
      });

      const result = await messageApi.addMessageSendUsers(paramList);
      console.log('발송대상 등록 현황:', idx+paramList.length);
    }
    // sendData.totalMembers.unshift(...filteredMembers);
    // unshiftPop(sendData.totalMembers, filteredMembers);
    const newRegDt = moment(page.sendDate).format("YYYY-MM-DD HH:mm:ss");
    filteredMembers.forEach(m => m.regDt = newRegDt);
    sendData.totalMembers = filteredMembers.concat(sendData.totalMembers);
    data.totalMembers.splice(0, data.totalMembers.length);

    this.searchTemp(1);
    this.searchSend(1);
    this.modalLoading = false;

    alert('발송대상을 등록하였습니다.');
  }

  async function searchUser() {
    // 전체 데이터 검색
    const params = _.cloneDeep(data.params);
    params.userTypeCds = data.selectedUserTypes.join(',');
    params.page = 1;
    params.limit = 999999; 

    this.modalLoading = true;
    try {
      const result = await memberApi.getUserList(params);
      data.totalMembers = result.data;
    } catch (error) {
      this.modalLoading = false;
      if (error.data) {
          console.log('## error:',error.data);
          alert('## error:'+error.data.message);
      }else{
          console.log('## network error', error);
          alert('## network error'+ JSON.stringify(error));
      }
    }
    this.modalLoading = false;
    
    this.searchTemp(1);
  }

  function searchTemp(page) {
    this.searchForTotal(data, page);
  }

  function searchSend(page) {
    this.searchForTotal(sendData, page);
  }

  function searchForTotal(data, page) {
    if (!isNaN(page)) {
      data.params.page = page;
    }

    let tmpDataList = [];
    const pageNo = data.params.page;
    let pageSize = data.params.limit;
    if (!isNaN(pageSize)) {
      pageSize = parseInt(pageSize);
    }
    const startIndex = pageSize * (pageNo-1);
    const endIndex = startIndex + pageSize - 1;
    
    console.log('startIndex, endIndex, totalMembers:', startIndex, endIndex, data.totalMembers);
    for (let i = startIndex; i <= endIndex; i++) {
      const member = data.totalMembers.at(i);
      if (member) {
        tmpDataList.push(member);
      }
    }
    data.list = tmpDataList;
    data.count = data.totalMembers.length;
  }

  return {
    detail,
    saveAndShowMessageTarget,
    saveWithSendMembers,
    remove,
    list,
    setSubjectOption,
    schoolGradeChanged,
    emailFormatChanged,
    openMemberSearchPopup,
    closeMemberSearchPopup,
    downloadTemplate,
    addToTempMembersExcel,
    readTempMembersExcel,
    addToTempMembers,
    addNoMember,
    removeFromTempMembers,
    searchUser,
    searchTemp,
    searchSend,
    searchForTotal,
  }
}
</script>